import { Select } from '@automata/ui';
import { MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';

import { Column } from 'components/ModelList/types';

export type Props = {
  sortableColumns: Column[];
  handleChange: (val: string) => void;
  defaultValue?: string;
};

const SortSelect = ({
  sortableColumns,
  handleChange,
  defaultValue,
}: Props): JSX.Element => {
  const [selectedValue, setSelectedValue] = useState<string>('');

  useEffect(() => {
    if (defaultValue) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue, sortableColumns]);

  return (
    <Select
      value={selectedValue}
      onChange={(e) => handleChange(String(e.target.value))}
      label="Sort by"
    >
      {sortableColumns.map((column) => (
        <MenuItem key={column.field} value={column.field}>
          {column.headerName}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SortSelect;
